import axios from "../axios";
import { handleFileDownload } from "../../utils";

const api = {
  getPaginatedSupplierCategories(paramsString, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/suppliers/categories?${paramsString}`, config).then(({ data }) => data);
  },
  createSupplierCategory(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/suppliers/categories", data, headers).then(({ data }) => data);
  },
  updateSupplierCategory({ id, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/suppliers/categories/${id}`, data, headers).then(({ data }) => data);
  },
  deleteSupplierCategory(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/suppliers/categories/${id}`, headers).then(({ data }) => data);
  },
  getAllSupplierCategories(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/suppliers/categories/all", config).then(({ data }) => data);
  },
  downloadSupplierCategoriesTemplate(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/suppliers/categories/template`, config).then(({ data, headers }) => {
      handleFileDownload(data, headers, "Supplier_categories_template");
    });
  },
  importSupplierCategories({ data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/suppliers/categories/import", data, headers).then(({ data }) => data);
  }
};

export default api;